const getEquipmentsQRCodes = {
  toastr: 'Equipment added',
  toastr1: 'The equipment has been successfully added.',
  toastrError: 'Equipment already registered',
  toastrError1: 'Enter this CNPJ or Name already registered'
};

export default getEquipmentsQRCodes;
